/*
 * Where: src/components/atoms/NavButton.js
 * What: Atom component for route navigation button.
 * Why: Reuse the smallest clickable element in header navigation.
 */
import React from 'react';

function NavButton({ label, path, active, onNavigate }) {
    const className = active ? 'nav-button active' : 'nav-button';

    return (
        <button
            className={className}
            type="button"
            onClick={() => {
                onNavigate(path);
            }}
        >
            {label}
        </button>
    );
}

export default NavButton;
